import { useEffect } from "react";
import { IFormSection, TSubmitType } from "../../types/common";
import {
  INCIDENT_TICKETING_API,
  API_TICKET_CATEGORIZATION_LIST,
  TICKETABLE_USERS_API,
} from "../../utils/apis";
import { URL_INCIDENT_TICKETING } from "../../utils/urls";
import useGet from "../common/useGet";
import { getRegister, getResultOptions } from "../../utils/helpers";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useIncidentTicketingForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Incident Ticketing",
      fields: [
        {
          field_name: "title",
          type: "text",
          label: "Title",
          props: { required: true },
        },
        {
          field_name: "category",
          type: "select",
          label: "Category",
          options_name: "categorization",
          props: { required: true },
        },
        {
          field_name: "severity",
          type: "select",
          label: "Severity",

          props: { required: true },
          options_data: [
            { id: "low", name: "Low" },
            { id: "medium", name: "Medium" },
            { id: "high", name: "High" },
            { id: "critical", name: "Critical" },
          ],
        },
        {
          field_name: "assigned_user",
          type: "select",
          label: "Assigned User",
          options_name: "asigned_users",
          props: { required: true },
        },

        {
          field_name: "estimated_duration",
          type: "number",
          label: "Estimated Duration",
          props: { required: true },
        },
        {
          field_name: "estimated_duration_unit",
          type: "select",
          label: "Duration Unit",

          props: { required: true },
          options_data: [
            { id: "minutes", name: "Minutes" },
            { id: "hours", name: "Hours" },
            { id: "days", name: "Days" },
          ],
        },
        {
          field_name: "rasier_phone_number_info",
          type: "tel",
          label: "Phone Number of Incident Raiser",
          props: {
            required: true,
          },
        },

        {
          field_name: "description",
          type: "textarea",
          label: "Description",
          props: { required: true, wide: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_INCIDENT_TICKETING);

  const getConfigOptions = () => {
    const { loadData: getCategorization, data: categorization } = useGet();

    const { loadData: getAssignedUsers, data: asigned_users } = useGet();

    useEffect(() => {
      getAssignedUsers({
        api: TICKETABLE_USERS_API,
        params: {},
      });
    }, []);

    useEffect(() => {
      getCategorization({
        api: API_TICKET_CATEGORIZATION_LIST,
        params: {},
      });
    }, []);

    return {
      categorization: getResultOptions(
        categorization,
        "category",
        "category_code",
      ),
      asigned_users: getResultOptions(asigned_users, "name", "value"),
    };
  };

  const options = getConfigOptions();

  return { sections, redirect, options };
};

export function submitIncidentTicketing(payload: any, id: number | null) {
  //  on update
  if (id) {
    return {
      id,
      api: INCIDENT_TICKETING_API,
      params: payload,
    };
  }
  // on create
  return {
    api: INCIDENT_TICKETING_API,
    params: payload,
  };
}
